export default [
  { to: 'utbildningar', title: 'Utbildningar' },
  { to: 'hemtjanst', title: 'Hemtjänst' },
  { to: 'sabo', title: 'Säbo' },
  { to: 'funktionsnedsattning', title: 'Funktionsnedsättning' },
  { to: 'halso_och_sjukvardsteamet', title: 'Hälso- och sjukvårdsteamet' },
];
